/**
 *
 * Asynchronously loads the component for Debt
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Debt = lazyLoad(
  () => import('./index'),
  module => module.Debt,
);
